"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationSetup = void 0;
var _reactRedux = require("react-redux");
var _recommendationSelectors = require("../../store/recommendation/recommendationSelectors");
var _react = require("react");
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _recommendationParser = require("../../store/recommendation/recommendationParser");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _useRecommendationStepperSetup = require("./useRecommendationStepperSetup");
var useRecommendationSetup = function useRecommendationSetup() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var recommendationRawData = (0, _reactRedux.useSelector)(_recommendationSelectors.selectRecommendationRawData);
  var productCatalogConfig = (0, _reactRedux.useSelector)(_widgetSelectors.selectProductCatalog);
  var replacedRecommendedProductWithAlternative = (0, _reactRedux.useSelector)(_widgetSelectors.selectReplacedRecommendedProductWithAlternative);
  var _useRecommendationSte = (0, _useRecommendationStepperSetup.useRecommendationStepperSetup)(),
    setupStepper = _useRecommendationSte.setupStepper;
  (0, _react.useEffect)(function () {
    var recommendationData = (0, _recommendationParser.parseRecommendationResponse)(recommendationRawData, productCatalogConfig, replacedRecommendedProductWithAlternative);
    dispatch((0, _recommendationActions.setRecommendation)(recommendationData));
    setupStepper();
  }, []);
};
exports.useRecommendationSetup = useRecommendationSetup;